import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { CreateVaraDto, ReadAtuacaoDto, ReadVaraDto } from '@/api.types';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { createVara, deleteVara, readVara, updateVara } from './vara.service';
import { readAtuacao } from '@/modules/business/atuacao/atuacao.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function VarasEditPage() {
  const { register, handleSubmit, reset } = useForm<CreateVaraDto>({
    defaultValues: { criminal: false, civel: false },
  });
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();
  const [registro, setRegistro] = useState<ReadVaraDto>();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);

  const [loading, setLoading] = useState(true);
  const [executing, setExecuting] = useState(false);

  const id = params.id ? Number(params.id) : 0;

  const [atuacoes, setAtuacoes] = useState<ReadAtuacaoDto[]>([]);
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    readAtuacao({ skip: 0, take: 1000, orderBy: "ASC" })
      .then((result) => {
        setAtuacoes(result[0]);
      })
      .catch((res) => {
        toast.error(String(res));
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Varas_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0 && !loading) {

      setExecuting(true)

      readVara({ id: id, take: 1, comAtuacao: true })
        .then((res) => {
          if (res) {
            const v = res[0].shift();
            setRegistro(v);
            reset(v);
          }
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => {
          setExecuting(false)
        })
    }
  }, [loading]);

  const onSubmit: SubmitHandler<CreateVaraDto> = (data) => {
    setLoading(true);
    const payload = {
      ...data,
      criminal: (data as any).criminal ?? false,
      civel: (data as any).civel ?? false,
    };
    if (id > 0) {

      updateVara(payload)
        .then(() => {
          toast.success("Vara Atualizada.");
          navigate(`${Links.Varas_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        });
    } else {
      createVara(payload)
        .then(() => {
          toast.success("Vara Cadastrada.");
          navigate(`${Links.Varas_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setLoading(false));
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    deleteVara(id)
      .then(() => {
        toast.warning("Vara Removida.");
        navigate(`${Links.Varas_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  if (loading)
    return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Varas / Centrais</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={(event) => { void handleSubmit(onSubmit)(event) }} >
        <div className="row">
          <div className="mb-3 col-md-2">
            <label htmlFor="ordem" className="form-label">
              Ordem:
            </label>
            <input
              autoFocus={true}
              title="Ordem"
              type="number"
              className="form-control"
              min={0}
              {...register('ordem')}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="atuacao" className="form-label">
              Atuação:{' '}
            </label>
            <select
              title="Atuações"
              className="form-select"
              {...register('atuacao.id')}
            >
              {atuacoes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3 col-md-6">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input
              title="Nome"
              type="text"
              className="form-control"
              {...register('nome')}
            />
          </div>

          <div className="mb-3 col-md-12 d-flex gap-4 align-items-center">
            <div className="d-flex align-items-center gap-2">
              <label htmlFor="criminal" className="form-label mb-0">
                Criminal?
              </label>
              <input
                id="criminal"
                type="checkbox"
                className="form-check-input"
                {...register('criminal')}
              />
            </div>
            <div className="d-flex align-items-center gap-2">
              <label htmlFor="civel" className="form-label mb-0">
                Cível?
              </label>
              <input
                id="civel"
                type="checkbox"
                className="form-check-input"
                {...register('civel')}
              />
            </div>
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: registro?.editadoPor,
              editadoEm: registro?.editadoEm!,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={executing}
              texto={btnSalvar}
              textoLoading={executing ? ' Salvando...' : 'Salvar'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.vara}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
